import { render, staticRenderFns } from "./Hover3.vue?vue&type=template&id=36be089c&scoped=true"
import script from "./Hover3.vue?vue&type=script&lang=js"
export * from "./Hover3.vue?vue&type=script&lang=js"
import style0 from "./Hover3.vue?vue&type=style&index=0&id=36be089c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be089c",
  null
  
)

export default component.exports